export const GET_PROFILE_OVERVIEW_START =
  'GET_PROFILE_OVERVIEW_START';
export const GET_PROFILE_OVERVIEW_SUCCESS =
  'GET_PROFILE_OVERVIEW_SUCCESS';
export const GET_PROFILE_OVERVIEW_ERROR =
  'GET_PROFILE_OVERVIEW_ERROR';
